<template>
    <div
        v-cloak
        class="row"
    >
        <div class="col-xs-12">
            <div class="box box-primary">
                <div class="box-header with-border">
                    <h3 class="box-title">PredefinedBody Categories</h3>
                    <div class="box-tools pull-right">
                        <button
                            class="btn btn-box-tool"
                            data-toggle="tooltip"
                            data-widget="collapse"
                            title="Collapse"
                            type="button"
                        >
                            <i class="fa fa-minus"></i>
                        </button>
                    </div>
                </div>
                <!-- /.box-header -->
                <div
                    v-if="categories.total"
                    class="box-body with-border clearfix"
                >
                    <BadgeTotal
                        :value="categories.total"
                        color="gray"
                        :label="`${$t('total')}: `"
                    />

                    <div
                        class="pagination-box"
                        @click="preventEnter"
                        @keydown="preventEnter"
                    >
                        <pagination
                            :class="isDisabled()"
                            :data="categories"
                            :limit="$root.paginator.settings.limit"
                            :size="$root.paginator.settings.size"
                            class="pull-right no-margin vue-pagination"
                            show-disabled
                            @pagination-change-page="getData"
                        >
                            <span slot="prev-nav">
                                <i class="fa fa-angle-double-left"></i>
                            </span>
                            <span slot="next-nav">
                                <i class="fa fa-angle-double-right"></i>
                            </span>
                        </pagination>
                    </div>
                </div>
                <div
                    v-if="!categories"
                    class="box-body"
                >
                    <p>There are no categories</p>
                </div>
                <div
                    v-else
                    class="box-body table-responsive no-padding"
                >
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Name</th>
                                <th>Group</th>
                                <th class="text-center">Active</th>
                                <th class="text-center">Body</th>
                                <th class="text-right">Created At</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="category in categories.data"
                                :key="category.id"
                            >
                                <td>{{ category.id }}</td>
                                <td>{{ category.name }}</td>
                                <td>
                                    <a
                                        :href="getRoute(category.group.id, 'group')"
                                        :title="category.group.name"
                                        >{{ category.group.name }}</a
                                    >
                                </td>
                                <td class="text-center">
                                    <ValueYesNo :value="category.active"></ValueYesNo>
                                </td>
                                <td class="text-center">
                                    <BadgeTotal
                                        :value="category.bodies_count"
                                        color="gray"
                                        title="Count"
                                    ></BadgeTotal>
                                </td>
                                <td class="text-right">
                                    {{ category.created_at }}
                                </td>
                                <td class="text-right">
                                    <a
                                        :href="getRoute(category.id, 'edit')"
                                        class="btn btn-sm btn-primary"
                                    >
                                        <i class="fa fa-edit"></i>
                                        <span class="sr-only">Edit</span>
                                    </a>
                                    <a
                                        :href="getRoute(category.id, 'show')"
                                        class="btn btn-sm btn-info"
                                    >
                                        <i class="fa fa-eye"></i>
                                        <span class="sr-only">Show</span>
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="box-footer clearfix">
                    <div
                        v-if="categories.total"
                        class="with-border clearfix"
                    >
                        <div
                            class="pagination-box"
                            @click="preventEnter"
                            @keydown="preventEnter"
                        >
                            <pagination
                                :class="isDisabled()"
                                :data="categories"
                                :limit="$root.paginator.settings.limit"
                                :size="$root.paginator.settings.size"
                                class="pull-right no-margin vue-pagination"
                                show-disabled
                                @pagination-change-page="getData"
                            >
                                <span slot="prev-nav">
                                    <i class="fa fa-angle-double-left"></i>
                                </span>
                                <span slot="next-nav">
                                    <i class="fa fa-angle-double-right"></i>
                                </span>
                            </pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ValueYesNo from '../../subcomponents/ValueYesNo';
import BadgeTotal from '../../subcomponents/BadgeTotal';

export default {
    components: {
        ValueYesNo,
        BadgeTotal,
    },
    data: function () {
        return {
            categories: {},
            disablePagination: true,
            pageNumber: this.$route.query.page,
            route: {
                show: this.$route.path + '/:id:',
                edit: this.$route.path + '/:id:/edit',
                group: '/category-groups/:id:',
            },
        };
    },
    mounted() {
        this.getData(this.pageNumber);
    },
    methods: {
        preventEnter: function (event) {
            if (this.disablePagination) {
                return event.preventDefault();
            }
        },
        getData(page = 1) {
            this.disablePagination = true;
            axios
                .get(
                    '/predefined-bodies/categories/data?page=' + page,
                    this.$router
                        .push({
                            path: this.$route.path,
                            query: {
                                page: page,
                            },
                            name: 'bodies.categories.list',
                        })
                        .catch(() => {})
                )
                .then((response) => {
                    this.categories = response.data.categories;
                    this.disablePagination = false;
                });
        },
        getRoute: function (id, type) {
            return this.route[type].replace(':id:', id);
        },
        isDisabled: function () {
            return this.disablePagination ? 'disabled-box' : '';
        },
    },
};
</script>
